'use client';

import { useEffect } from 'react';
import { isEmpty } from '@cat-ecom/common/utils/commonUtils';
import { areEqualArrays } from 'components/price-and-fitment-context-entry/utils';
import { useAlternateContext } from './alternate-context-provider';
import { CartResponse } from 'services/cart/types';

interface CartDetailsContextEntryProps {
  cartDetails: CartResponse;
  listenerKey: string;
}

const CartDetailsContextEntry = ({
  cartDetails: cartDetailsProps,
  listenerKey
}: CartDetailsContextEntryProps) => {
  const { cartDetails, setCartDetails } = useAlternateContext();

  useEffect(() => {
    const cartDetailsPropsArray = Object.keys(cartDetailsProps ?? {});
    const cartDetailsContextArray = Object.keys(cartDetails ?? {});
    if (
      !isEmpty(cartDetailsPropsArray) &&
      !areEqualArrays(cartDetailsPropsArray, cartDetailsContextArray)
    ) {
      setCartDetails(cartDetailsProps);
    }
  }, [cartDetailsProps, listenerKey, cartDetails, setCartDetails]);

  return null;
};

export default CartDetailsContextEntry;
